import { useEffect, useRef } from "react";

export default function useTableLongPress(onLongPress, onOpen) {
  const press = useRef(null);
  const suppressClick = useRef(false);
  const cancel = () => {
    clearTimeout(press.current?.timer);
    press.current = null;
  };
  useEffect(() => () => clearTimeout(press.current?.timer), []);

  return (table) => ({
    role: "button",
    tabIndex: 0,
    "aria-haspopup": "dialog",
    onPointerDown: (event) => {
      if (event.button !== 0 || event.isPrimary === false) return;
      cancel();
      suppressClick.current = false;
      press.current = {
        x: event.clientX, y: event.clientY,
        timer: setTimeout(() => {
          suppressClick.current = true;
          onLongPress(table);
          press.current = null;
        }, 520),
      };
    },
    onPointerMove: (event) => {
      if (press.current && Math.hypot(event.clientX - press.current.x, event.clientY - press.current.y) > 10) {
        suppressClick.current = true;
        cancel();
      }
    },
    onPointerUp: cancel,
    onPointerCancel: () => { suppressClick.current = true; cancel(); },
    onPointerLeave: cancel,
    onClick: (event) => {
      if (suppressClick.current) {
        event.preventDefault();
        suppressClick.current = false;
        return;
      }
      onOpen(table);
    },
    onContextMenu: (event) => {
      event.preventDefault();
      cancel();
      if (!suppressClick.current) onLongPress(table);
      suppressClick.current = true;
    },
    onKeyDown: (event) => {
      if (event.key === "ContextMenu" || (event.shiftKey && event.key === "F10")) {
        event.preventDefault();
        onLongPress(table);
      } else if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onOpen(table);
      }
    },
  });
}
